import SharedRadioInput from '../shared/RadioInput';

import {
  addMissingMandatoryField,
  removeMissingMandatoryField,
} from 'reducers/commercialFormReducer';

import type { MessageProps } from '../shared/Message/Message.types';

interface CommercialRadioInputProps {
  section: number;
  label: string;
  options: Array<{ value: string; label: string }>;
  value?: string;
  onChange?: (value: string) => void;
  message?: Omit<MessageProps, 'section'> & { section?: number };
  required?: boolean;
  infoText?: string;
  stacked?: boolean;
  disabled?: boolean;
  subLabel?: string;
  [x: string]: any;
}

const noop = () => ({ type: 'commercialForm/noop' });

const CommercialRadioInput = (props: CommercialRadioInputProps) => {
  const formActions = {
    addMissingMandatoryField,
    removeMissingMandatoryField,
    addRemark: noop,
    removeRemark: noop,
    updateRemark: noop,
    addFile: noop,
    removeFile: noop,
  };

  return (
    <SharedRadioInput
      {...props}
      formStateKey="commercialForm"
      formActions={formActions}
    />
  );
};

export default CommercialRadioInput;
